// Ring 0 — RunState singleton. NO Phaser imports.
//
// Single source of truth for in-flight run state: seed, current floor,
// pocket cards, optional cashier result. Mutation of `RunState.pocket`
// is reserved for `PocketSystem` only (Plan 04 / HAND-05 sole-writer
// invariant). Other subsystems READ but never WRITE pocket directly.

import type { Card } from './types';

export interface CashierResult {
  locked5: Card[];
  handName: string;
  score: number;
}

class RunStateClass {
  seed = 1;
  currentFloor = 0;
  pocket: Card[] = [];
  cashier?: CashierResult;
  runStartTime = 0;

  reset(): void {
    this.currentFloor = 0;
    this.pocket = [];
    this.cashier = undefined;
    this.runStartTime = 0;
  }
}

export const RunState = new RunStateClass();
